import tw, { styled } from "twin.macro"

export const Wrapper = tw.div`px-2 max-w-40 mx-auto pt-3 pb-3 md:pb-10 md:pt-10 text-center col-span-4`

export const Title = styled.h3<TitleProps>`
  ${({ large }) => (large === "true" ? tw`px-1 text-18 leading-none ` : tw`text-12 md:text-18 leading-none md:leading-none  md:`)}
  ${tw`font-bold mb-3-2 md:mb-3 uppercase`}
`

export const Description = tw.p`
  text-12 leading-none mb-2 md:mb-2-8
`

type TitleProps = {
  large: "true" | "false"
}
